import { Box, Button } from '@primerai/thread';
import styled from 'styled-components';

export const FormInputsWrapper = styled(Box)``;

export const SignInForm = styled.form`
  margin-top: 0;
`;

export const SubmitButton = styled(Button)`
  width: 100%;
`;

export const FadeInPasswordField = styled(Box)`
  opacity: 0;

  &.fadeIn {
    opacity: 100%;
    transition: opacity 0.3s;
  }
`;
